import script from "./EditablePdfComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditablePdfComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditablePdfComponent.vue?vue&type=style&index=0&id=ac2e525a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac2e525a"]])

export default __exports__